function Button({buttonText, buttonType="button"}) {
    return (
        <button type={buttonType} className="button">
            {buttonText}
        </button>
    )
}

export default Button;